tinymce.addI18n("da", {
    "#": "#",
    "Accessibility": "Tilg\xe6ngelighed",
    "Accordion": "Fold-ud",
    "Accordion body...": "Fold-ud indhold...",
    "Accordion summary...": "Fold-ud oversigt...",
    "Action": "Handling",
    "Activity": "Aktivitet",
    "Address": "Adresse",
    "Advanced": "Avanceret",
    "Align": "Juster",
    "Align center": "Centrer",
    "Align left": "Venstre-juster",
    "Align right": "H\xf8jre-juster",
    "Alignment": "Justering",
    "Alignment {0}": "Justering {0}",
    "All": "Alle",
    "Alternative description": "Alternativ beskrivelse",
    "Alternative source": "Alternativ kilde",
    "Alternative source URL": "Alternativ kilde URL",
    "Anchor": "Anker",
    "Anchor...": "Anker...",
    "Anchors": "Ankre",
    "Animals and Nature": "Dyr og natur",
    "Arrows": "Pile",
    "B": "B",
    "Background color": "Baggrundsfarve",
    "Background color {0}": "Baggrundsfarve {0}",
    "Black": "Sort",
    "Block": "Blok\xe9r",
    "Block {0}": "Blok {0}",
    "Blockquote": "Citatblok",
    "Blocks": "Blokke",
    "Blue": "Bl\xe5",
    "Blue component": "Bl\xe5 komponent",
    "Body": "Br\xf8dtekst",
    "Bold": "Fed",
    "Border": "Kant",
    "Border color": "Kantfarve",
    "Border style": "Kantstil",
    "Border width": "Kantbredde",
    "Bottom": "Bund",
    "Browse files": "Gennemse filer",
    "Browse for an image": "S\xf8g efter et billede",
    "Browse links": "Gennemse links",
    "Bullet list": "Punktopstillet liste",
    "Cancel": "Annuller",
    "Caption": "Tekst",
    "Cell": "Celle",
    "Cell padding": "Indvendig margin i celle",
    "Cell properties": "Celleegenskaber",
    "Cell spacing": "Celleafstand",
    "Cell styles": "Celle styling",
    "Cell type": "Celletype",
    "Center": "Midte",
    "Characters": "Tegn",
    "Characters (no spaces)": "Tegn (uden mellemrum)",
    "Circle": "Cirkel",
    "Class": "Klasse",
    "Clear formatting": "Nulstil formatering",
    "Close": "Luk",
    "Code": "Kode",
    "Code sample...": "Kodeeksempel...",
    "Code view": "Kodevisning",
    "Color Picker": "Farvev\xe6lger",
    "Color swatch": "Farvepr\xf8ve",
    "Cols": "Kolonne",
    "Column": "Kolonne",
    "Column clipboard actions": "Kolonne udklipsholder handlinger",
    "Column group": "Kolonnegruppe",
    "Column header": "Kolonne overskrift",
    "Constrain proportions": "Begr\xe6ns proportioner",
    "Copy": "Kopier",
    "Copy column": "Kopier kolonne",
    "Copy row": "Kopier r\xe6kke",
    "Could not find the specified string.": "Kunne ikke finde s\xf8getekst.",
    "Could not load emojis": "Kunne ikke indl\xe6se emojier",
    "Count": "Antal",
    "Currency": "Valuta",
    "Current window": "Aktuelle vindue",
    "Custom color": "Brugerdefineret farve",
    "Custom...": "Brugerdefineret...",
    "Cut": "Klip",
    "Cut column": "Klip kolonne",
    "Cut row": "Klip r\xe6kke",
    "Dark Blue": "M\xf8rkebl\xe5",
    "Dark Gray": "M\xf8rkegr\xe5",
    "Dark Green": "M\xf8rkegr\xf8n",
    "Dark Orange": "M\xf8rkeorange",
    "Dark Purple": "M\xf8rkelilla",
    "Dark Red": "M\xf8rker\xf8d",
    "Dark Turquoise": "M\xf8rketurkis",
    "Dark Yellow": "M\xf8rkegul",
    "Dashed": "Stiplet",
    "Date/time": "Dato/klokkesl\xe6t",
    "Decrease indent": "Formindsk indrykning",
    "Default": "Standard",
    "Delete accordion": "Slet fold-ud",
    "Delete column": "Slet kolonne",
    "Delete row": "Slet r\xe6kke",
    "Delete table": "Slet tabel",
    "Dimensions": "Dimensioner",
    "Disc": "Udfyldt cirkel",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Prikket",
    "Double": "Dobbelt",
    "Drop an image here": "Slip et billede her",
    "Dropped file type is not supported": "Den placerede fil type er ikke underst\xf8ttet",
    "Edit": "Rediger",
    "Embed": "Indlejr",
    "Emojis": "Emojier",
    "Emojis...": "Emojier...",
    "Error": "Fejl",
    "Error: Form submit field collision.": "Fejl: Form submit felt kollision",
    "Error: No form element found.": "Fejl: Ingen form element fundet.",
    "Extended Latin": "Udvidet Latin",
    "Failed to initialize plugin: {0}": "Mislykket initiering a plugin: {0}",
    "Failed to load plugin url: {0}": "Mislykket indl\xe6sning af plugin url: {0}",
    "Failed to load plugin: {0} from url {1}": "Mislykket plugin indl\xe6sning: {0} fra url {1}",
    "Failed to upload image: {0}": "Mislykket billed-upload: {0}",
    "File": "Fil",
    "Find": "S\xf8g",
    "Find (if searchreplace plugin activated)": "Find (hvis search/replace plugin er aktiveret)",
    "Find and Replace": "Find og erstat",
    "Find and replace...": "Find og erstat...",
    "Find in selection": "Find i det valgte",
    "Find whole words only": "Find kun hele ord",
    "Flags": "Flag",
    "Focus to contextual toolbar": "Fokuser p\xe5 kontekstuel v\xe6rkt\xf8jslinje",
    "Focus to element path": "Fokuser p\xe5 elementvej",
    "Focus to menubar": "Fokus p\xe5 menulinjen",
    "Focus to toolbar": "Fokus p\xe5 v\xe6rkt\xf8jslinjen",
    "Font": "Skrifttype",
    "Font size {0}": "Skriftst\xf8rrelse {0}",
    "Font sizes": "Skriftst\xf8rrelse",
    "Font {0}": "Skrifttype {0}",
    "Fonts": "Skrifttyper",
    "Food and Drink": "F\xf8de og drikke",
    "Footer": "Sidefod",
    "Format": "Formater",
    "Format {0}": "Format {0}",
    "Formats": "Formater",
    "Fullscreen": "Fuld sk\xe6rm",
    "G": "G",
    "General": "Generelt",
    "Gray": "Gr\xe5",
    "Green": "Gr\xf8n",
    "Green component": "Gr\xf8n komponent",
    "Groove": "Rille",
    "Handy Shortcuts": "Praktiske Genveje",
    "Header": "Overskrift",
    "Header cell": "Sidehoved celle",
    "Heading 1": "Overskrift 1",
    "Heading 2": "Overskrift 2",
    "Heading 3": "Overskrift 3",
    "Heading 4": "Overskrift 4",
    "Heading 5": "Overskrift 5",
    "Heading 6": "Overskrift 6",
    "Headings": "Overskrifter",
    "Height": "H\xf8jde",
    "Help": "Hj\xe6lp",
    "Hex color code": "Hex farvekode",
    "Hidden": "Skjult",
    "Horizontal align": "Horisontal justering",
    "Horizontal line": "Vandret linje",
    "Horizontal space": "Vandret mellemrum",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID skal starte med et bogstav, og m\xe5 kun efterf\xf8lges af bogstaver, tal, bindestreg, punktum, kolon eller underscore.",
    "Image is decorative": "Billede er dekorativt",
    "Image list": "Billedliste",
    "Image title": "Billedtitel",
    "Image...": "Billede...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Image Proxy HTTP fejl: Kunne ikke finde Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Image Proxy HTTP fejl: Forkert Image Proxy URL",
    "ImageProxy HTTP error: Rejected request": "Image Proxy HTTP fejl: Anmodning afvist",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Image Proxy HTTP fejl: Ukendt Image Proxy fejl",
    "Increase indent": "For\xf8g indrykning",
    "Inline": "Inline",
    "Insert": "Inds\xe6t",
    "Insert Template": "Inds\xe6t Skabelon",
    "Insert accordion": "Inds\xe6t fold-ud",
    "Insert column after": "Inds\xe6t kolonne efter",
    "Insert column before": "Inds\xe6t kolonne f\xf8r",
    "Insert date/time": "Inds\xe6t dato/klokkesl\xe6t",
    "Insert image": "Inds\xe6t billede",
    "Insert link (if link plugin activated)": "Inds\xe6t link (hvis link plugin er aktiveret)",
    "Insert row after": "Inds\xe6t r\xe6kke efter",
    "Insert row before": "Inds\xe6t r\xe6kke f\xf8r",
    "Insert table": "Inds\xe6t tabel",
    "Insert template...": "Inds\xe6t skabelon...",
    "Insert video": "Inds\xe6t video",
    "Insert/Edit code sample": "Inds\xe6t/Ret kodeeksempel",
    "Insert/edit image": "Inds\xe6t/rediger billede",
    "Insert/edit link": "Inds\xe6t/rediger link",
    "Insert/edit media": "Inds\xe6t/rediger medier",
    "Insert/edit video": "Inds\xe6t/rediger video",
    "Inset": "Fors\xe6nket",
    "Invalid hex color code: {0}": "Ugyldig hex farvekode: {0}",
    "Invalid input": "Ugyldig indtastning",
    "Italic": "Kursiv",
    "Justify": "Justering",
    "Keyboard Navigation": "Navigation med tastatur",
    "Language": "Sprog",
    "Learn more...": "L\xe6r mere...",
    "Left": "Venstre",
    "Left to right": "Venstre mod h\xf8jre",
    "Light Blue": "Lysebl\xe5",
    "Light Gray": "Lysegr\xe5",
    "Light Green": "Lysegr\xf8n",
    "Light Purple": "Lyslilla",
    "Light Red": "Lyser\xf8d",
    "Light Yellow": "Lysegul",
    "Line height": "Linjeh\xf8jde",
    "Link list": "Linkliste",
    "Link...": "Link...",
    "List Properties": "List indstillinger",
    "List properties...": "List indstillinger...",
    "Loading emojis...": "Indl\xe6ser emojier...",
    "Loading...": "Indl\xe6ser...",
    "Lower Alpha": "Sm\xe5 bogstaver",
    "Lower Greek": "Sm\xe5 gr\xe6ske",
    "Lower Roman": "Sm\xe5 romertal",
    "Match case": "Forskel p\xe5 store og sm\xe5 bogstaver",
    "Mathematical": "Matematiske tegn",
    "Media poster (Image URL)": "Medieplakat (billede URL)",
    "Media...": "Medie...",
    "Medium Blue": "Medium bl\xe5",
    "Medium Gray": "Mellemgr\xe5",
    "Medium Purple": "Medium lilla",
    "Merge cells": "Flet celler",
    "Middle": "Midte",
    "Midnight Blue": "Midnats-bl\xe5",
    "More...": "Mere...",
    "Name": "Navn",
    "Navy Blue": "Marinebl\xe5",
    "New document": "Nyt dokument",
    "New window": "Nyt vindue",
    "Next": "N\xe6ste",
    "No": "Nej",
    "No alignment": "Ingen justering",
    "No color": "Ingen farve",
    "Nonbreaking space": "H\xe5rdt mellemrum",
    "None": "Ingen",
    "Numbered list": "Nummereret liste",
    "OR": "ELLER",
    "Objects": "Objekter",
    "Ok": "Ok",
    "Open help dialog": "\xc5bn hj\xe6lpedialog",
    "Open link": "\xc5ben link",
    "Open link in...": "\xc5bn link med...",
    "Open popup menu for split buttons": "\xc5ben popup menu for split knapper",
    "Orange": "Orange",
    "Outset": "Begyndelse",
    "Page break": "Sideskift",
    "Paragraph": "Afsnit",
    "Paste": "S\xe6t ind",
    "Paste as text": "Inds\xe6t som tekst",
    "Paste column after": "Inds\xe6t kolonne efter",
    "Paste column before": "Inds\xe6t kolonne f\xf8r",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": '"Inds\xe6t" er nu i Ren Tekst tilstand. Indhold vil nu blive indsat som ren tekst, indtil du sl\xe5r denne funktion fra igen.',
    "Paste or type a link": "Inds\xe6t eller skriv et link",
    "Paste row after": "Inds\xe6t r\xe6kke efter",
    "Paste row before": "Inds\xe6t r\xe6kke f\xf8r",
    "Paste your embed code below:": "Inds\xe6t din indlejrede kode herunder:",
    "People": "Folk",
    "Plugins": "Plugins",
    "Plugins installed ({0}):": "Installerede plugins ({0}):",
    "Powered by {0}": "Drevet af {0}",
    "Pre": "Pre",
    "Preferences": "Pr\xe6ferencer",
    "Preformatted": "Forudformateret",
    "Premium plugins:": "Premium plugins:",
    "Press the Up and Down arrow keys to resize the editor.": "Tryk Op eller Ned tasten for at tilpasse st\xf8rrelsen p\xe5 editoren",
    "Press the arrow keys to resize the editor.": "Tryk p\xe5 piletasterne for at tilpasse st\xf8rrelsen p\xe5 editoren",
    "Press {0} for help": "Tryk {0} for hj\xe6lp",
    "Preview": "Forh\xe5ndsvisning",
    "Previous": "Forrige",
    "Print": "Print",
    "Print...": "Udskriv...",
    "Purple": "Lilla",
    "Quotations": "Anf\xf8rselstegn",
    "R": "R",
    "Range 0 to 255": "Interval 0 til 255",
    "Red": "R\xf8d",
    "Red component": "R\xf8d komponent",
    "Redo": "Gendan",
    "Remove": "Slet",
    "Remove color": "Fjern farve",
    "Remove link": "Fjern link",
    "Replace": "Erstat",
    "Replace all": "Erstat alle",
    "Replace with": "Erstat med",
    "Resize": "Skaler",
    "Restore last draft": "Genopret sidste kladde",
    "Reveal or hide additional toolbar items": "Vis eller skjul ekstra menu punkter",
    "Rich Text Area": "Tekst omr\xe5de",
    "Rich Text Area. Press ALT-0 for help.": "Tekst omr\xe5de. Tryk p\xe5 ALT-0 for hj\xe6lp.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Tekst omr\xe5de. Tryk ALT-F9 for menu. Tryk ALT-F10 for v\xe6rkt\xf8jslinje. Tryk ALT-0 for hj\xe6lp",
    "Ridge": "Ryg",
    "Right": "H\xf8jre",
    "Right to left": "H\xf8jre mod venstre",
    "Row": "R\xe6kke",
    "Row clipboard actions": "R\xe6kke udklipsholder handlinger",
    "Row group": "R\xe6kke gruppe",
    "Row header": "R\xe6kke overskrift",
    "Row properties": "R\xe6kkeegenskaber",
    "Row type": "R\xe6kke type",
    "Rows": "R\xe6kke",
    "Save": "Gem",
    "Save (if save plugin activated)": "Gem (hvis gem plugin er aktiveret)",
    "Scope": "Omr\xe5de",
    "Search": "S\xf8g",
    "Select all": "V\xe6lg alle",
    "Select...": "V\xe6lg...",
    "Selection": "Valg",
    "Shortcut": "Genvej",
    "Show blocks": "Vis blokke",
    "Show caption": "Vis overskrift",
    "Show invisible characters": "Vis usynlige tegn",
    "Size": "St\xf8rrelse",
    "Solid": "Solid",
    "Source": "Kilde",
    "Source code": "Kildekode",
    "Special Character": "Specialtegn",
    "Special character...": "Specielle tegn...",
    "Split cell": "Del celle",
    "Square": "Firkant",
    "Start list at number": "Start liste ved nummer",
    "Strikethrough": "Gennem-streget",
    "Style": "Typografi",
    "Subscript": "S\xe6nket skrift",
    "Superscript": "H\xe6vet skrift",
    "Switch to or from fullscreen mode": "Skift til eller fra fuldsk\xe6rmstilstand",
    "Symbols": "Symboler",
    "System Font": "Systemskrifttype",
    "Table": "Tabel",
    "Table caption": "Tabeltekst",
    "Table properties": "Tabelegenskaber",
    "Table styles": "Tabel styling",
    "Template": "Skabelon",
    "Templates": "Skabeloner",
    "Text": "Tekst",
    "Text color": "Tekstfarve",
    "Text color {0}": "Tekstfarve {0}",
    "Text to display": "Tekst som skal vises",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "URL\u2019en som du angav ser ud til at v\xe6re en e-mailadresse. \xd8nsker du at tilf\xf8je det kr\xe6vede pr\xe6fiks mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL\u2019en som du angav ser ud til at v\xe6re et eksternt link. \xd8nsker du at tilf\xf8je det kr\xe6vede pr\xe6fiks http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "URL'en som du angav ser ud til at v\xe6re et eksternt link. \xd8nsker du at tilf\xf8je det n\xf8dvendige https:// pr\xe6fiks?",
    "Title": "Titel",
    "To open the popup, press Shift+Enter": "Tryk skift + enter for at \xe5bne pop op",
    "Toggle accordion": "Skift fold-ud",
    "Tools": "V\xe6rkt\xf8jer",
    "Top": "Top",
    "Travel and Places": "Rejser og steder",
    "Turquoise": "Turkis",
    "Underline": "Understreget",
    "Undo": "Fortryd",
    "Upload": "Upload",
    "Uploading image": "Uploader billede",
    "Upper Alpha": "Store bogstaver",
    "Upper Roman": "Store romertal",
    "Url": "Url",
    "User Defined": "Brugerdefineret",
    "Valid": "Gyldig",
    "Version": "Version",
    "Vertical align": "Vertikal justering",
    "Vertical space": "Lodret mellemrum",
    "View": "Gennemse",
    "Visual aids": "Visuel hj\xe6lp",
    "Warn": "Advar",
    "White": "Hvid",
    "Width": "Bredde",
    "Word count": "Optalte ord",
    "Words": "Ord",
    "Words: {0}": "Ord: {0}",
    "Yellow": "Gul",
    "Yes": "Ja",
    "You are using {0}": "Du benytter {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Du har ikke gemte \xe6ndringer. Er du sikker p\xe5 at du vil forts\xe6tte?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Din browser underst\xf8tter ikke direkte adgang til udklipsholder. Benyt Ctrl+X/C/ tastaturgenveje i stedet for.",
    "alignment": "justering",
    "austral sign": "austral-tegn",
    "cedi sign": "cedi-tegn",
    "colon sign": "kolon-tegn",
    "cruzeiro sign": "cruzeiro-tegn",
    "currency sign": "valutategn",
    "dollar sign": "dollartegn",
    "dong sign": "dong-tegn",
    "drachma sign": "drakmer-tegn",
    "euro-currency sign": "euro-tegn",
    "example": "eksempel",
    "formatting": "formatering",
    "french franc sign": "fransk frank-tegn",
    "german penny symbol": "tysk penny-symbol",
    "guarani sign": "guarani-tegn",
    "history": "historie",
    "hryvnia sign": "hryvnia-tegn",
    "indentation": "indrykning",
    "indian rupee sign": "indisk rupee-tegn",
    "kip sign": "kip-tegn",
    "lira sign": "lira-tegn",
    "livre tournois sign": "livre tournois-tegn",
    "manat sign": "manat-tegn",
    "mill sign": "mill-tegn",
    "naira sign": "naira-tegn",
    "new sheqel sign": "ny sheqel-tegn",
    "nordic mark sign": "nordisk mark-tegn",
    "peseta sign": "peseta-tegn",
    "peso sign": "peso-tegn",
    "ruble sign": "rubel-tegn",
    "rupee sign": "rupee-tegn",
    "spesmilo sign": "spesmilo-tegn",
    "styles": "stile",
    "tenge sign": "tenge-tegn",
    "tugrik sign": "tugrik-tegn",
    "turkish lira sign": "tyrkisk lira-tegn",
    "won sign": "won-tegn",
    "yen character": "yen-tegn",
    "yen/yuan character variant one": "yen/yuan-tegn variant en",
    "yuan character": "yuan-tegn",
    "yuan character, in hong kong and taiwan": "yuan-tegn, i hong kong og taiwan",
    "{0} characters": "{0} tegn",
    "{0} columns, {1} rows": "{0} Kolonner, {1} R\xe6kker",
    "{0} words": "{0} ord"
});